export default __webpack_public_path__ + "assets/hongkong-flag.png";